import actions from "@/store/modules/content/actions";
import mutations from "@/store/modules/content/mutations";
import state from "@/store/modules/content/state";

export default {
    actions,
    mutations,
    state
}